import React, { useState, useEffect } from "react";
import Axios from "axios";
import { Snackbar, Alert } from "@mui/material";
const getFlogicPr = (proj) =>
  proj?.panel?.VT5000_CONFIG?.FlogicPr || proj?.panel?.VT5000_CONFIG?.flogicpr || [];


const getArgus = (proj) =>
  proj?.VT5000_CONFIG?.ArgusTablePr ||
  proj?.VT5000_CONFIG?.argustablepr ||
  proj?.panel?.VT5000_CONFIG?.ArgusTablePr ||
  proj?.panel?.VT5000_CONFIG?.argustablepr ||
  [];


const getOutputZones = (proj) =>
  proj?.panel?.VT5000_CONFIG?.OutputZones || proj?.panel?.VT5000_CONFIG?.outputzones || [];

const readStoredProject = () => {
  try {
    return JSON.parse(sessionStorage.getItem("selectedProject")) || null;
  } catch {
    return null;
  }
};

const CloudProLFConfig = ({
  lfOptions,
  selectedLF,
  setSelectedLF,
  handleAddLFOption,
  lfList,
  setLfList,
  selectedCell,
  activeMode,
  // handleSaveCell,
  updateLF,
  DEVICE_OPTIONS,
  ZONE_OPTIONS,
  selectedDevice,
  setSelectedDevice,
  selectedZone,
  setSelectedZone,
  OUTPUT_ZONES,
  handleClose,
  handleSaveCauseEffect,
  tableData,
  effects,
}) => {
  const [selectedLoop, setSelectedLoop] = useState(0);
  const [logicExpression, setLogicExpression] = useState("(");
  const [logicExpressionList, setLogicExpressionList] = useState(["("]);
  const [isDevicesDialogOpen, setDevicesDialogOpen] = useState(false);
  const [isZonesDialogOpen, setZonesDialogOpen] = useState(false);
  const [isLogicFunctionsDialogOpen, setLogicFunctionsDialogOpen] = useState(false);
  const [isVTNetsDialogOpen, setVTNetsDialogOpen] = useState(false);
  const [activeLfId, setActiveLfId] = useState(null);
  const [showOperators, setShowOperators] = useState(false);
  const [selectedDeviceType, setSelectedDeviceType] = useState("");
  const [isSensorEventDialogOpen, setSensorEventDialogOpen] = useState(false);
  const [isModuleEventDialogOpen, setModuleEventDialogOpen] = useState(false);
  const [selectedZoneDevices, setSelectedZoneDevices] = useState([]);
  const [isOutputZoneDialogOpen, setOutputZoneDialogOpen] = useState(false);
  const [selectedOutputButton, setSelectedOutputButton] = useState(null);
  const [selectedDeviceAddress, setSelectedDeviceAddress] = useState(null);
  const [outputButtons, setOutputButtons] = useState(["0", "0", "0", "0"]);
  const [isZoneEventDialogOpen, setZoneEventDialogOpen] = useState(false);
  const [selectedZoneText, setSelectedZoneText] = useState("");

  const [newLFIndex, setNewLFIndex] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("success");

  const [project, setProject] = useState(readStoredProject);

  const [refreshKey, setRefreshKey] = useState(0);
  const cleanName = (n) => (n || "").replace(/\u0000/g, "").trim();
  useEffect(() => {
    const refreshProject = () => {
      const fresh = readStoredProject();
      if (!fresh) return;

      setProject(fresh);
      setNewLFIndex(null);

  
      const first = getFlogicPr(fresh).findIndex((lf) => lf?.programmed === 1);
      if (first === -1) {
        setSelectedLF(null);
        setLfList([]);
        setOutputButtons(["0", "0", "0", "0"]);
      } else {
        setSelectedLF(`L${first + 1}`);
      }
      setRefreshKey((k) => k + 1);
    };

    window.addEventListener("storage", refreshProject);
    window.addEventListener("project-refreshed", refreshProject);
    return () => {
      window.removeEventListener("storage", refreshProject);
      window.removeEventListener("project-refreshed", refreshProject);
    };
   
  }, []);

  
  useEffect(() => {
    if (!project) return;
    if (selectedLF) return;

    const flogicPr = getFlogicPr(project);
    if (!flogicPr.length) return;

    const firstProgrammedIndex = flogicPr.findIndex((lf) => lf && lf.programmed === 1);

    if (firstProgrammedIndex !== -1) {
      setSelectedLF(`L${firstProgrammedIndex + 1}`);
    }
 
  }, [project]);

  useEffect(() => {
    if (!selectedLF) return;

    const freshProject = readStoredProject();
    if (!freshProject) return;

    const lfNumberRaw = selectedLF.replace("L", "");
    const lfNumber = parseInt(lfNumberRaw, 10);

    if (isNaN(lfNumber) || lfNumber < 1) {
      console.warn("Invalid LF selected:", selectedLF);
      return;
    }

    const lfIndex = lfNumber - 1;
    const flogicPr = getFlogicPr(freshProject);

    const emptyForm = () => {
      setOutputButtons(["0", "0", "0", "0"]);
      setLfList([
        {
          id: Date.now(),
          name: selectedLF,
          number: lfNumber,
          device: "",
          zone: "",
          logic: "(",
          condition: "AND",
          delay: 0,
          duration: 0,
          outputs: [],
        },
      ]);
    };

    if (!flogicPr || !flogicPr[lfIndex]) {
      console.warn("flogicPr not found at index:", lfIndex);
      emptyForm();
      return;
    }

    const logic = flogicPr[lfIndex];

    if (logic?.programmed === 1) {
      const loadedOutputButtons = (logic.outputZones || Array(4).fill(0)).map((zone) =>
        zone > 0 ? `OZ-${zone}` : "0"
      );
      const expressionParts = GenerateExpressionPartsFromC1Level(logic.c1Level || []);
      const expressionText = expressionParts.length > 0 ? expressionParts.join("") : "(";

      setOutputButtons(loadedOutputButtons);
      setLfList([
        {
          id: Date.now(),
          name: selectedLF,
          number: lfNumber,
          device: "",
          zone: "",
          logic: expressionText,
          condition: "AND",
          delay: logic.delay || 0,
          duration: logic.duration || 0,
          outputs: loadedOutputButtons,
        },
      ]);
    } else {
    
      emptyForm();
    }
    
  }, [selectedLF, refreshKey]);
const openDevicesDialog = (lfId) => {
  const fresh = readStoredProject();
  if (fresh) setProject(fresh);
  setActiveLfId(lfId);
  setDevicesDialogOpen(true);
};

const openZonesDialog = (lfId) => {
  const fresh = readStoredProject() || project;
  setProject(fresh);
  setActiveLfId(lfId);

  const zoneDevices = [];
  (getArgus(fresh) || []).forEach((loopDevices, loopIdx) => {
    (loopDevices || []).forEach((d, i) => {
      if (d?.zone > 0 && cleanName(d.name) !== "") {
        zoneDevices.push({ ...d, loopIdx, address: i + 1 });
      }
    });
  });
  setSelectedZoneDevices(zoneDevices);
  setZonesDialogOpen(true);
};
  const handleLFSelect = (lfName) => {
    setSelectedLF(lfName);
   
    const clickedIndex = parseInt(lfName.replace("L", ""), 10) - 1;
    const flogicPr = getFlogicPr(project);
    if (flogicPr[clickedIndex]?.programmed === 1) {
      setNewLFIndex(null);
    }
  };

  const handleZoneEventClick = (eventType) => {
    const finalText = `${selectedZoneText}${eventType}`;
    insertToken(activeLfId, finalText);
    setZoneEventDialogOpen(false);
    setTimeout(() => setShowOperators(true), 0);
  };

  const handleDeviceSelect = (deviceName) => {
    setLfList((prev) =>
      prev.map((lf) => {
        if (lf.id !== activeLfId) return lf;
        let base = lf.logic || "(";
        if (!base.startsWith("(")) base = "(" + base;
        return { ...lf, logic: base + deviceName };
      })
    );
    setDevicesDialogOpen(false);
    setTimeout(() => setShowOperators(true), 0);
  };

  const insertToken = (lfId, token) => {
    setLfList((prev) =>
      prev.map((lf) => {
        if (lf.id !== lfId) return lf;
        let base = lf.logic || "(";
        if (!base.startsWith("(")) base = "(" + base;
        return { ...lf, logic: base + token };
      })
    );
  };

  const handleSensorEventClick = (eventType) => {
    const finalText = `${selectedDeviceAddress}${eventType}`;
    insertToken(activeLfId, finalText);
    setSensorEventDialogOpen(false);
    setTimeout(() => setShowOperators(true), 0);
  };

  const handleModuleEventClick = (eventType) => {
    const finalText = `${selectedDeviceAddress}${eventType}`;
    insertToken(activeLfId, finalText);
    setModuleEventDialogOpen(false);
    setTimeout(() => setShowOperators(true), 0);
  };

  const GenerateOperandFromElementName = (name) => {
    let operand = 0;
    if (name.startsWith("Pn")) {
      const netAddress = parseInt(name.substring(2, 4));
      operand += netAddress * 16777216;
      name = name.substring(4);
    }
    let eventCode = name.slice(-1);
    switch (eventCode) {
      case "A": operand += 1 * 65536; name = name.slice(0, -1); break;
      case "P": operand += 2 * 65536; name = name.slice(0, -1); break;
      case "F": operand += 3 * 65536; name = name.slice(0, -1); break;
      case "E": operand += 4 * 65536; name = name.slice(0, -1); break;
      case "T": operand += 5 * 65536; name = name.slice(0, -1); break;
      default: break;
    }
    if (name.startsWith("L") && name[3] === "D") {
      const loopIndex = parseInt(name.substring(1, 3)) - 1;
      const deviceIndex = parseInt(name.substring(4)) - 1;
      operand += 1 + loopIndex * 240 + deviceIndex;
    } else if (name.startsWith("L") && name[3] === "M") {
      const loopIndex = parseInt(name.substring(1, 3)) - 1;
      const deviceIndex = parseInt(name.substring(4)) - 1;
      operand += 1 + loopIndex * 240 + deviceIndex;
    } else if (name.startsWith("Z")) {
      const zoneIndex = parseInt(name.substring(1));
      operand += 3856 + zoneIndex;
    } else if (name.startsWith("Lf")) {
      const lfIndex = parseInt(name.substring(2));
      operand += 4240 + lfIndex;
    } else {
      console.error(`Unknown element format: ${name}`);
      return null;
    }
    return operand;
  };

  const GenerateExpressionPartsFromC1Level = (c1Level) => {
    const expression = [];
    c1Level.forEach((group, groupIndex) => {
      if (!group || group.c1Operat === 0) return;
      const hasOperands = group.c2Operand.some((op) => op > 0);
      if (!hasOperands) return;
      if (groupIndex > 0 && group.c1Operat !== 6) {
        switch (group.c1Operat) {
          case 1: expression.push(" & "); break;
          case 2: expression.push(" | "); break;
          case 3: expression.push(" ^ "); break;
          case 4: expression.push(" ! "); break;
          default: break;
        }
      }
      expression.push("(");
      group.c2Operand.forEach((operand, index) => {
        if (!operand || operand === 0) return;
        expression.push(GenerateElementNameFromOperand(operand));
        const operator = group.c2Operator[index + 1];
        switch (operator) {
          case 1: expression.push(" & "); break;
          case 2: expression.push(" | "); break;
          case 3: expression.push(" ^ "); break;
          case 4: expression.push(" ! "); break;
          default: break;
        }
      });
      expression.push(")");
    });
    return expression;
  };

  const GenerateElementNameFromOperand = (operand) => {
    let baseOperand = operand;
    baseOperand = baseOperand % 16777216;
    const eventCode = Math.floor(baseOperand / 65536);
    baseOperand = baseOperand % 65536;
    let eventSuffix = "";
    switch (eventCode) {
      case 1: eventSuffix = "A"; break;
      case 2: eventSuffix = "P"; break;
      case 3: eventSuffix = "F"; break;
      case 4: eventSuffix = "E"; break;
      case 5: eventSuffix = "T"; break;
      default: break;
    }
    if (baseOperand >= 1 && baseOperand <= 3840) {
      const deviceIndex = baseOperand - 1;
      const loop = Math.floor(deviceIndex / 240) + 1;
      const address = (deviceIndex % 240) + 1;
      return `L${String(loop).padStart(2, "0")}D${String(address).padStart(3, "0")}${eventSuffix}`;
    }
    if (baseOperand >= 3856 && baseOperand < 4240) {
      const zone = baseOperand - 3856;
      return `Z${String(zone).padStart(3, "0")}${eventSuffix}`;
    }
    if (baseOperand >= 4240) {
      const lf = baseOperand - 4240;
      return `Lf${String(lf).padStart(3, "0")}`;
    }
    return "";
  };

  const convertLogicToList = (logic) => {
    return logic.match(/L\d{2}[DM]\d{3}[APFET]?|Z\d{3}[AFE]?|Lf\d{3}|[()&|^!]/g) || [];
  };

  const handleFinalSave = async () => {
    const currentLF = lfList[0];
    if (!currentLF) { console.error("No Logic Function Selected"); return; }

    const logic = currentLF.logic?.trim() || "";

    if (!logic.endsWith(")")) {
      setAlertType("error");
      setAlertMsg("Complete the Logic Function with ')'.");
      setOpenSnackbar(true);
      return;
    }

    const lfNumber = currentLF.number;
    if (isNaN(lfNumber) || lfNumber < 1) { console.error("Invalid LF number"); return; }

    const lfIndex = lfNumber - 1;

    const flogicPr = getFlogicPr(project);
    if (!flogicPr || !flogicPr[lfIndex]) {
      console.error("flogicPr index not found:", lfIndex);
      return;
    }

    const logicExpressionList = convertLogicToList(currentLF.logic);

    const parseC1LevelFromExpression = (expressionList) => {
      let c1Level = [];
      let currentGroup = null;
      let groupIndex = 0;
      let operandIndex = 0;
      let firstGroup = true;
      for (let i = 0; i < expressionList.length; i++) {
        const token = expressionList[i].trim();
        if (token.includes("(")) {
          let operat = 5;
          if (!firstGroup) {
            if (token.startsWith("&")) operat = 1;
            else if (token.startsWith("|")) operat = 2;
            else if (token.startsWith("^")) operat = 3;
            else if (token.startsWith("!")) operat = 4;
          }
          currentGroup = { c1Operat: operat, c2Operand: [0, 0, 0, 0], c2Operator: [5, 0, 0, 0] };
          operandIndex = 0;
          firstGroup = false;
        } else if (/^[A-Za-z]/.test(token)) {
          if (operandIndex < 4) {
            const operand = GenerateOperandFromElementName(token);
            currentGroup.c2Operand[operandIndex] = operand !== null && !isNaN(operand) ? operand : 0;
          }
        } else if (["&", "|", "^", "!"].includes(token)) {
          const code = { "&": 1, "|": 2, "^": 3, "!": 4 }[token];
          if (operandIndex < 3) currentGroup.c2Operator[operandIndex + 1] = code;
          operandIndex++;
        } else if (token === ")") {
          const validOperandCount = currentGroup.c2Operand.filter((op) => op > 0).length;
          if (validOperandCount < 4 && validOperandCount > 0) currentGroup.c2Operator[validOperandCount] = 6;
          c1Level.push(currentGroup);
          groupIndex++;
          operandIndex = 0;
          if (groupIndex >= 4) break;
        }
      }
      if (c1Level.length < 4) c1Level.push({ c1Operat: 6, c2Operand: [0, 0, 0, 0], c2Operator: [0, 0, 0, 0] });
      while (c1Level.length < 4) c1Level.push({ c1Operat: 0, c2Operand: [0, 0, 0, 0], c2Operator: [0, 0, 0, 0] });
      return c1Level;
    };

    const parsedC1Level = parseC1LevelFromExpression(logicExpressionList);

    flogicPr[lfIndex].c1Level = parsedC1Level;
    flogicPr[lfIndex].delay = parseInt(currentLF.delay) || 0;
    flogicPr[lfIndex].duration = parseInt(currentLF.duration) || 0;
    flogicPr[lfIndex].programmed = 1;
    flogicPr[lfIndex].outputZones = outputButtons.map((btn) => {
      if (typeof btn === "string" && btn.startsWith("OZ-")) return parseInt(btn.replace("OZ-", ""));
      return 0;
    });
    flogicPr[lfIndex].fLogicAss = logicExpressionList.some((item) => item.includes("LF")) ? 1 : 0;

    sessionStorage.setItem("selectedProject", JSON.stringify(project));

    const userEmail = localStorage.getItem("userEmail");
    const panelContentId = sessionStorage.getItem("panelContentId");

    try {
      const response = await Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_flogicpr`, {
        projectId: project.project_id,
        panelContentId,
        flogicpr: flogicPr,
        email: userEmail,
      });

      if (response.data.success) {
      
        setAlertType("success");
        setOpenSnackbar(true);
        setAlertMsg("Logic Function saved successfully");
        setNewLFIndex(null);

        const refreshed = readStoredProject();
        if (refreshed) setProject(refreshed);

        const valueRows = (tableData || []).filter((r) => !r.isGroup);
        const selectedRow = valueRows[selectedCell?.rowIndex];
        const rowId = selectedRow?.rowId ?? null;
        const colId = effects?.[selectedCell?.colIndex]?.colId ?? null;
        const lfNum = lfList[0]?.number ?? null;

        if (rowId && colId && lfNum !== null) {
          await handleSaveCauseEffect(rowId, colId, "LF", lfNum, "add");
        }
      } else {
        console.error("Failed to save Logic Function");
        setAlertType("error");
        setOpenSnackbar(true);
        setAlertMsg("Failed to save Logic Function");
      }
    } catch (error) {
      console.error("Error saving Logic Function:", error);
      setAlertType("error");
      setOpenSnackbar(true);
      setAlertMsg(`Error saving Logic Function: ${error?.message || error}`);
    }
  };

  const handleDelete = async () => {
    const currentLF = lfList[0];
    if (!currentLF) { console.error("No Logic Function Selected"); return; }

    const lfNumber = currentLF.number || parseInt(selectedLF?.replace("L", ""), 10);
    const lfIndex = lfNumber - 1;

    if (isNaN(lfIndex) || lfIndex < 0) { console.error("Invalid lfIndex:", lfIndex); return; }

    const flogicPr = getFlogicPr(project);
    if (!flogicPr || !flogicPr[lfIndex]) {
      console.error("flogicPr index not found:", lfIndex);
      return;
    }

    flogicPr[lfIndex].delay = 0;
    flogicPr[lfIndex].duration = 0;
    flogicPr[lfIndex].fLogicAss = 0;
    flogicPr[lfIndex].programmed = 0;
    flogicPr[lfIndex].outputZones = Array(4).fill(0);
    flogicPr[lfIndex].c1Level = [
      { c1Operat: 5, c2Operand: [0, 0, 0, 0], c2Operator: [5, 0, 0, 0] },
      { c1Operat: 0, c2Operand: [0, 0, 0, 0], c2Operator: [0, 0, 0, 0] },
      { c1Operat: 0, c2Operand: [0, 0, 0, 0], c2Operator: [0, 0, 0, 0] },
      { c1Operat: 0, c2Operand: [0, 0, 0, 0], c2Operator: [0, 0, 0, 0] },
    ];

    sessionStorage.setItem("selectedProject", JSON.stringify(project));

    const userEmail = localStorage.getItem("userEmail");
    const panelContentId = sessionStorage.getItem("panelContentId");

    try {
      const response = await Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_flogicpr`, {
        projectId: project.project_id,
        panelContentId,
        flogicpr: flogicPr,
        email: userEmail,
      });

      if (response.data.success) {
       
        setAlertType("success");
        setOpenSnackbar(true);
        setAlertMsg("Logic Function deleted successfully");
      
        setNewLFIndex(null);
        setSelectedLF(null);
        setLfList([]);
        setOutputButtons(["0", "0", "0", "0"]);

        const refreshed = readStoredProject();
        if (refreshed) setProject(refreshed);
      } else {
      
        setAlertType("error");
        setOpenSnackbar(true);
        setAlertMsg("Failed to delete Logic Function");
      }
    } catch (error) {
      console.error("Error deleting Logic Function:", error);
      setAlertType("error");
      setOpenSnackbar(true);
      setAlertMsg(`Error deleting Logic Function: ${error?.message || error}`);
    }
  };

  const opBtnStyle = {
    borderRadius: "6px",
    border: "1px solid #007bff",
    background: "white",
    color: "#007bff",
    cursor: "pointer",
    fontSize: "10px",
  };
  const blueBtnStyle = {
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "#007bff",
    color: "#fff",
    cursor: "pointer",
  };
  const overlayStyle = (z) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: z,
  });

  return (
    <div>
      {/* LF BUTTONS */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>
        {getFlogicPr(project).map((lfItem, index) => {
          const isNewLF = index === newLFIndex;
          
          if (!lfItem || (lfItem.programmed !== 1 && !isNewLF)) return null;

          const lfName = `L${index + 1}`;
          return (
            <button
              key={lfName}
              onClick={() => handleLFSelect(lfName)}
              style={{
                padding: "6px 10px",
                background: selectedLF === lfName ? "#007bff" : "#eee",
                color: selectedLF === lfName ? "#fff" : "#000",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "12px",
              }}
            >
              {lfName}
              {isNewLF && lfItem?.programmed !== 1 ? " *" : ""}
            </button>
          );
        })}

        {/* + New LF button */}
        <button
          onClick={() => {
            const flogic = getFlogicPr(project);
            const unprogrammedIndex = flogic.findIndex((lf) => !lf || lf.programmed !== 1);

            if (unprogrammedIndex === -1) {
              alert("All Logic Functions are already programmed");
              return;
            }

            setNewLFIndex(unprogrammedIndex);

            const lfName = `L${unprogrammedIndex + 1}`;
            handleLFSelect(lfName);
          }}
          style={{
            padding: "6px 10px",
            background: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "12px",
          }}
        >
          + New LF
        </button>
      </div>

      {/* LF FORM */}
      {lfList.map((lf) => (
        <div
          key={lf.id}
          style={{ border: "1px solid #ccc", padding: "10px", marginBottom: "10px", borderRadius: "6px" }}
        >
          <b>Logic Function {!isNaN(lf.number) ? lf.number : "?"}</b>

          <textarea
            placeholder="("
            value={lf.logic}
            onChange={(e) => {
              let val = e.target.value;
              if (!val.startsWith("(")) val = "(" + val;
              updateLF(lf.id, "logic", val);
            }}
            style={{ width: "100%", marginTop: "5px" }}
          />

          {showOperators && (
            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
              <button onClick={() => insertToken(lf.id, " & ")} style={opBtnStyle}>AND (&)</button>
              <button onClick={() => insertToken(lf.id, " | ")} style={opBtnStyle}>OR (|)</button>
              <button
                onClick={() => {
                  insertToken(lf.id, ")");
                  setShowOperators(false);
                }}
                style={opBtnStyle}
              >
                )
              </button>
            </div>
          )}

          {/* DEVICES DIALOG */}
          {isDevicesDialogOpen && (
  <div style={overlayStyle(999)}>
    <div style={{ background: "#fff", padding: "20px", borderRadius: "8px", width: "900px", maxHeight: "90vh", overflow: "auto" }}>
      <h6>Select Device</h6>

      {/* LOOP TABS */}
      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "12px" }}>
        {getArgus(project).map((loopDevs, i) => (
          <button
            key={i}
            onClick={() => setSelectedLoop(i)}
            style={{
              padding: "6px 10px", borderRadius: "5px", border: "1px solid #007bff", cursor: "pointer",
              background: selectedLoop === i ? "#007bff" : "#fff",
              color: selectedLoop === i ? "#fff" : "#007bff",
            }}
          >
            Loop {i + 1} ({(loopDevs || []).filter((d) => cleanName(d?.name)).length})
          </button>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: "10px" }}>
        {(getArgus(project)?.[selectedLoop] || [])
          .map((device, originalIndex) => ({ device, originalIndex }))
          .filter(({ device }) => {
            const name = cleanName(device?.name).toLowerCase();
            if (!name) return false;
            return (
              device.deviceType === 0 ||
              device.isCallPoint === 1 ||
              name.includes("input") ||
              name.includes("gas")
            );
          })
          .map(({ device, originalIndex }) => {
            const deviceName = cleanName(device.name);
            return (
              <button
                key={originalIndex}
                style={{ padding: "12px", borderRadius: "6px", backgroundColor: "transparent", border: "1px solid #ccc", cursor: "pointer" }}
                onClick={() => {
                  setSelectedDevice(deviceName);
                  const loopNum = String(selectedLoop + 1).padStart(2, "0");
                  const deviceNum = String(originalIndex + 1).padStart(3, "0");
                  const isSensor = device.deviceType === 0;
                  setSelectedDeviceAddress(`L${loopNum}${isSensor ? "D" : "M"}${deviceNum}`);
                  setDevicesDialogOpen(false);
                  if (isSensor) {
                    setSelectedDeviceType("sensor");
                    setTimeout(() => setSensorEventDialogOpen(true), 100);
                  } else {
                    setSelectedDeviceType("module");
                    setTimeout(() => setModuleEventDialogOpen(true), 100);
                  }
                }}
              >
                {deviceName}
              </button>
            );
          })}
      </div>

      <button style={{ marginTop: "20px", padding: "10px 20px" }} className="btn save" onClick={() => setDevicesDialogOpen(false)}>
        Close
      </button>
    </div>
  </div>
)}

          {/* SENSOR EVENT DIALOG */}
          {isSensorEventDialogOpen && (
            <div style={overlayStyle(999)}>
              <div style={{ background: "#fff", padding: "20px", borderRadius: "8px", width: "400px" }}>
                <h6>Sensor Event</h6>
                <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                  <button onClick={() => handleSensorEventClick("A")}>Alarm(A)</button>
                  <button onClick={() => handleSensorEventClick("F")}>Fault(F)</button>
                  <button onClick={() => handleSensorEventClick("E")}>Exclusion(E)</button>
                </div>
                <button style={{ marginTop: "20px" }} className="btn save" onClick={() => setSensorEventDialogOpen(false)}>
                  Close
                </button>
              </div>
            </div>
          )}

          {/* MODULE EVENT DIALOG */}
          {isModuleEventDialogOpen && (
            <div style={overlayStyle(9999)}>
              <div style={{ background: "#fff", padding: "20px", borderRadius: "8px", width: "500px" }}>
                <h6>Module Event</h6>
                <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                  <button onClick={() => handleModuleEventClick("A")}>Active(A)</button>
                  <button onClick={() => handleModuleEventClick("F")}>Fault(F)</button>
                  <button onClick={() => handleModuleEventClick("E")}>Exclusion(E)</button>
                  <button onClick={() => handleModuleEventClick("T")}>Technological(T)</button>
                </div>
                <button style={{ marginTop: "20px" }} className="btn save" onClick={() => setModuleEventDialogOpen(false)}>
                  Close
                </button>
              </div>
            </div>
          )}

          {/* ACTION BUTTONS */}
          <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap", marginTop: "10px" }}>
            <button style={blueBtnStyle} onClick={() => openDevicesDialog(lf.id)}>Select Device</button>
<button style={blueBtnStyle} onClick={() => openZonesDialog(lf.id)}>Select Zone</button>

            {/* ZONE DIALOG */}
            {isZonesDialogOpen && (
              <div style={overlayStyle(9999)}>
                <div style={{ background: "#fff", padding: "20px", borderRadius: "8px", width: "700px", maxHeight: "80vh", overflow: "auto" }}>
                  <h6>Select Zone</h6>
                  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "20px" }}>
                    {[...new Set(selectedZoneDevices.map((d) => d.zone))].map((zoneNo) => (
                      <button
                        key={zoneNo}
                        style={{ padding: "10px 15px", border: "1px solid #ccc", borderRadius: "6px", cursor: "pointer" }}
                        onClick={() => {
                          setSelectedZoneText(`Z${String(zoneNo).padStart(3, "0")}`);
                          setZonesDialogOpen(false);
                          setTimeout(() => setZoneEventDialogOpen(true), 100);
                        }}
                      >
                        Zone {zoneNo}
                      </button>
                    ))}
                  </div>
                  <hr />
                  <h6>Zone Devices</h6>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(140px,1fr))", gap: "10px", marginTop: "15px" }}>
                    {selectedZoneDevices.map((device, index) => (
                      <div key={index} style={{ border: "1px solid #ddd", borderRadius: "6px", padding: "10px" }}>
                        <div><b>{device.name?.replace(/\u0000/g, "").trim()}</b></div>
                        <div>Zone: {device.zone}</div>
                        <div>Type: {device.deviceType === 0 ? "Sensor" : "Module"}</div>
                      </div>
                    ))}
                  </div>
                  <button style={{ marginTop: "20px", padding: "10px 20px" }} className="btn save" onClick={() => setZonesDialogOpen(false)}>
                    Close
                  </button>
                </div>
              </div>
            )}

            {/* ZONE EVENT DIALOG */}
            {isZoneEventDialogOpen && (
              <div style={overlayStyle(9999)}>
                <div style={{ background: "#fff", padding: "20px", borderRadius: "8px", width: "400px" }}>
                  <h6>Zone Event</h6>
                  <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                    <button onClick={() => handleZoneEventClick("A")}>Alarm(A)</button>
                    <button onClick={() => handleZoneEventClick("F")}>Fault(F)</button>
                    <button onClick={() => handleZoneEventClick("E")}>Exclusion(E)</button>
                  </div>
                  <button style={{ marginTop: "20px" }} className="btn save" onClick={() => setZoneEventDialogOpen(false)}>
                    Close
                  </button>
                </div>
              </div>
            )}

            <button style={blueBtnStyle}>VT-NET</button>
            <button onClick={() => setLogicFunctionsDialogOpen(true)} style={blueBtnStyle}>
              Logic Function
            </button>
          </div>

          {/* DELAY / DURATION */}
          <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
            <input type="number" placeholder="Delay" value={lf.delay} onChange={(e) => updateLF(lf.id, "delay", e.target.value)} />
            <input type="number" placeholder="Duration" value={lf.duration} onChange={(e) => updateLF(lf.id, "duration", e.target.value)} />
          </div>

          {/* OUTPUT ZONES */}
          <div style={{ marginTop: "10px" }}>
            <b>Output Zones</b>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)" }}>
              {[0, 1, 2, 3].map((index) => (
                <button
                  key={index}
                  style={blueBtnStyle}
                  onClick={() => {
                    setSelectedOutputButton(index);
                    setOutputZoneDialogOpen(true);
                  }}
                >
                  {outputButtons[index]}
                </button>
              ))}
            </div>
          </div>

          {/* OUTPUT ZONE DIALOG */}
          {isOutputZoneDialogOpen && (
            <div style={overlayStyle(9999)}>
              <div style={{ background: "#fff", padding: "20px", borderRadius: "8px", width: "700px", maxHeight: "80vh", overflow: "auto" }}>
                <h6>Select Output Zone</h6>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                  {getOutputZones(project)
                    .map((zone, index) => ({ ...zone, zoneNumber: index + 1 }))
                    .filter((zone) => zone.programmed === 1)
                    .map((zone, index) => {
                      const deviceNames = zone.devices
                        ?.filter((d) => d.address > 0)
                        ?.map((d) => {
                          const device = getArgus(project)?.[d.loop - 1]?.[d.address - 1];
                          return device?.name || `L${d.loop}D${d.address}`;
                        });
                      return (
                        <div key={index} style={{ border: "1px solid #ccc", borderRadius: "8px", padding: "15px", marginBottom: "10px" }}>
                          <button
                            style={blueBtnStyle}
                            onClick={() => {
                              const updatedButtons = [...outputButtons];
                              updatedButtons[selectedOutputButton] = `OZ-${zone.zoneNumber}`;
                              setOutputButtons(updatedButtons);
                              updateLF(lf.id, "outputs", updatedButtons);
                              setOutputZoneDialogOpen(false);
                            }}
                          >
                            Output Zone {zone.zoneNumber}
                          </button>
                          <div><b>Devices:</b></div>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                            {deviceNames?.map((name, i) => (
                              <span key={i} style={{ padding: "5px 10px", background: "#f1f1f1", borderRadius: "5px", fontSize: "12px" }}>
                                {name?.replace(/\u0000/g, "").trim()}
                              </span>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                </div>
                <button style={{ marginTop: "20px", padding: "10px 20px" }} className="btn save" onClick={() => setOutputZoneDialogOpen(false)}>
                  Close
                </button>
              </div>
            </div>
          )}

          {/* SAVE / DELETE / CANCEL */}
          <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
            <button className="add-btn" onClick={handleFinalSave}>Save</button>
            <button className="btn pdf" onClick={handleDelete}>Delete</button>
            <button className="btn save" onClick={handleClose}>Cancel</button>
          </div>
        </div>
      ))}

      <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={() => setOpenSnackbar(false)}>
        <Alert onClose={() => setOpenSnackbar(false)} severity={alertType} variant="filled">
          {alertMsg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CloudProLFConfig;